// src/lib/training.js
import { callAi } from "./geminiClient";

/** 언어별 리소스/프롬프트 구성 */
function buildResources(lang) {
  if (lang === "zh-CN") {
    const clinicInfo = `
${process.env.REACT_APP_CN_CLINIC_NAME} 信息
- 地址: 首尔市江南区德黑兰路109号，10楼 (驿三洞，江南第一大厦)
- 电话号码: 02-501-2120
- 诊疗时间: 周一/三/五 (10:00~21:00), 周二/四 (14:00~21:00), 周六 (10:00~17:00)(各分店不同), 周日/公休日 休诊
- 专业领域: 仅专注减肥专业诊疗，20年经验，全国34家分店
- 特征: 可非面对面处方，每日夜间诊疗(平日)
- 主要项目及价格:
  - ${process.env.REACT_APP_CN_JIBANG_SAYACK}: 2周 5万韩元起(活动时), 1个月 15万韩元~
  - ${process.env.REACT_APP_SIKTAM_SAYAK}: 1个月 28万韩元~(汤剂, 12阶段定制)
  - 辅助胶囊: ${process.env.REACT_APP_CN_JIBANG_KILL}/${process.env.REACT_APP_CN_DOKSO_KILL}/${process.env.REACT_APP_CN_SUMYEON_KILL}
- 代表院长: 曾任江南/狎鸥亭诊疗院长, 20年以上经验
`.trim();

    const prompts = {
      // 1) 거절유형 → 대화 스크립트 생성
      scriptGen: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的减肥咨询辅导专家。请基于[韩医院信息]与当前情况，使用亲切的敬语体，生成咨询组长与患者的自然对话脚本，遵守 A.I.R.C 框架(认可→分离→重构→确认)。
[韩医院信息]
${clinicInfo}

[当前情况]
{situation}

[要求]
- 用中文回答，但专有名词保持韩文
- 每句以“**咨询组长:**”或“**患者:**”开头
- 以咨询/诊断为中心，不强调销售`,

      // 2) 코칭 분석
      coaching: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的首席咨询教练。请根据[韩医院信息]与A.I.R.C框架，对下述脚本提供结构化反馈(中文, 敬语体)。
[韩医院信息]
${clinicInfo}

[分析脚本]
---
{script}
---

### 📈 总评
### 👍 优点
- ...
### 💡 改进点
- ...`,

      // 3) 시뮬레이터
      simFirstMsg: `请扮演 '{name}' 画像，在与咨询师刚接通电话时说出第一句话(1~2句)。
[画像说明]
{description}
[参考资料]
${clinicInfo}`,

      simChat: `延续对话，继续扮演 '{name}'。遵循画像特征并参考[韩医院信息]，以亲切敬语体回答。
[画像说明]
{description}
[对话记录]
{history}
[韩医院信息]
${clinicInfo}`,

      simReport: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的首席咨询教练。请基于[韩医院信息]与以下对话，为咨询师撰写改进型反馈报告(中文, 敬语体)。
[对话记录] (咨询师 vs '{name}')
---
{history}
---
[韩医院信息]
${clinicInfo}

### 📊 模拟总评
### 👍 优点
### 💡 改进点
### 🏆 综合分数(100分)`,

      ui: {
        roleConsultant: "咨询师",
        rolePatient: "患者",
        errorEmpty: "请输入要分析的脚本。",
        mustLogin: "请先登录后再使用。",
      },

      objections: {
        price: '患者说 "价格太贵了"，对费用感到负担。',
        decision: '患者说 "我要和家人商量一下"，推迟决定。',
        trust: '患者说 "不知道有没有效果"，对项目效果表示怀疑。',
        process: '患者说 "我先考虑一下再联系您"，没有明确理由想结束咨询。',
      },

      personas: {
        "price-sensitive": {
          name: "价格敏感型 大学生",
          description:
            "打工维持生活，极度关注性价比。倾向于询问 " + process.env.REACT_APP_CN_JIBANG_SAYACK + "/" + process.env.REACT_APP_CN_SIKTAM_SAYAK + " 价格差异并寻找更便宜选项。",
        },
        "skeptical-worker": {
          name: "怀疑效果型 上班族",
          description:
            "多次减肥失败，逻辑质疑效果/副作用/反弹。想弄清楚 " + process.env.REACT_APP_CN_SIKTAM_SAYAK + " 12阶段定制的具体差异。",
        },
        "indecisive-homemaker": {
          name: "保留决定型 家庭主妇",
          description:
            "费用需与丈夫商量，常以“再考虑”推迟决定，对施压敏感。",
        },
      },
    };

    return { clinicInfo, prompts };
  }

  // 한국어 (기본)
  const clinicInfo = `
${process.env.REACT_APP_CLINIC_NAME} 정보
- 위치: 서울시 강남구 테헤란로 109, 10층(역삼동, 강남제일빌딩)
- 전화: 02-501-2120
- 진료시간: 월/수/금(10~21), 화/목(14~21), 토(10~17) *지점별 상이
- 특징: 20년 노하우, 전국 34개 지점, 비대면 처방 가능, 평일 야간진료
- 주요 프로그램/가격:
  - ${process.env.REACT_APP_JIBANG_SAYACK}: 2주 5만원~(이벤트), 1개월 15만원~
  - ${process.env.REACT_APP_SIKTAM_SAYAK}: 1개월 28만원~(탕제/12단계 맞춤)
  - 보조캡슐: ${process.env.REACT_APP_JIBANG_KILL}/${process.env.REACT_APP_DOKSO_KILL}/${process.env.REACT_APP_SUMYEON_KILL}
- 대표원장: 강남/압구정 진료원장 역임, 20년 이상
`.trim();

  const prompts = {
    scriptGen: `당신은 '${process.env.REACT_APP_CLINIC_NAME}'의 상담 코칭 전문가예요. 아래 [정보]와 현재 상황을 바탕으로 A.I.R.C(인정→분리→재구성→확인)를 지키며 '해요체'로 자연스러운 상담 스크립트를 만들어줘요.
[정보]
${clinicInfo}

[현재 상황]
{situation}

[요청]
- 상담팀장/환자 대사로 구성(각 문장 시작에 **상담팀장:** / **환자:**)
- 판매 압박 금지, 상담/진단 중심`,

    coaching: `당신은 수석 상담 코치예요. [정보]와 A.I.R.C 원칙으로 아래 스크립트를 분석해 구조화 피드백을 주세요(해요체).
[정보]
${clinicInfo}

[분석 스크립트]
---
{script}
---

### 📈 총평
### 👍 잘한 점
- ...
### 💡 개선할 점
- ...`,

    simFirstMsg: `당신은 지금부터 '{name}' 페르소나예요. 상담사와 통화 연결 직후 건네는 첫 멘트를 1~2문장으로 작성해줘요.
[페르소나 설명]
{description}
[참고]
${clinicInfo}`,

    simChat: `대화를 이어서 '{name}'로 응답해줘요. 페르소나 특성과 [정보]를 반영해 '해요체'로 자연스럽게.
[페르소나 설명]
{description}
[대화 기록]
{history}
[정보]
${clinicInfo}`,

    simReport: `수석 상담 코치로서 아래 대화에 대한 개선형 피드백 리포트를 작성해줘요(해요체).
[대화 기록] (상담사 vs '{name}')
---
{history}
---
[정보]
${clinicInfo}

### 📊 시뮬레이션 총평
### 👍 잘한 점
### 💡 개선할 점
### 🏆 종합 점수(100점 만점)`,

    ui: {
      roleConsultant: "상담사",
      rolePatient: "환자",
      errorEmpty: "분석할 상담 스크립트를 입력해주세요.",
      mustLogin: "로그인 후 사용해 주세요",
    },

    objections: {
      price: '환자가 "가격이 너무 비싸요"라고 함(비용 부담).',
      decision: '환자가 "가족과 상의해봐야 해요"라고 함(결정 유보).',
      trust: '환자가 "효과가 있을지 모르겠어요"라고 함(신뢰 부족).',
      process: '환자가 "일단 생각해보고 연락드릴게요"라고 함(프로세스 마찰).',
    },

    personas: {
      "price-sensitive": {
        name: "가격 민감형 대학생",
        description:
          "아르바이트로 생활, 가성비 최우선. " + process.env.REACT_APP_JIBANG_SAYACK + "/" + process.env.REACT_APP_SIKTAM_SAYAK + " 가격 차이 질문, 더 저렴한 옵션 탐색.",
      },
      "skeptical-worker": {
        name: "효과 의심형 직장인",
        description:
          "여러 다이어트 실패, 효과/부작용/요요에 대한 논리적 검증 선호. " + process.env.REACT_APP_SIKTAM_SAYAK + " 12단계 맞춤 차이 궁금.",
      },
      "indecisive-homemaker": {
        name: "결정 유보형 주부",
        description:
          "비용은 남편과 상의 필요. 압박에 민감, '생각해볼게요'로 결정 미룸.",
      },
    },
  };

  return { clinicInfo, prompts };
}

/** 공통 유틸 */
function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}
function ensureLoginOrThrow(lang) {
  const raw = (typeof localStorage !== "undefined" && localStorage.getItem("user")) || "";
  const user = raw ? JSON.parse(raw) : null;
  if (!user) {
    alert(lang === "zh-CN" ? "请先登录后再使用。" : "로그인 후 사용해 주세요");
    if (typeof window !== "undefined") window.location.href = "/login";
    throw new Error("NOT_AUTHENTICATED");
  }
  return user;
}

/** 공개 API */
export const TrainingAI = {
  /** 1) 거절 유형별 상담 스크립트 생성 */
  async generateScript({ objectionKey }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const situation = prompts.objections?.[objectionKey] || "";
    const prompt = (prompts.scriptGen || "").replace("{situation}", situation);

    const data = await callAi({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      api_name: "counsel_training",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text;
    if (!text) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer: text };
  },

  /** 2) 스크립트 코칭 분석 */
  async coaching({ script }) {
    if (!script?.trim()) throw new Error("분석할 상담 스크립트를 입력해주세요.");
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const prompt = (prompts.coaching || "").replace("{script}", script.trim());

    const data = await callAi({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      api_name: "counsel_training",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text;
    if (!text) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer: text };
  },

  /** 3) 시뮬레이터: 첫 멘트 */
  async simFirst({ persona }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const p = prompts.personas?.[persona];
    if (!p) throw new Error("유효하지 않은 페르소나입니다.");

    const prompt = (prompts.simFirstMsg || "")
      .replace("{name}", p.name)
      .replace("{description}", p.description);

    const data = await callAi({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      api_name: "counsel_training",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text;
    if (!text) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer: text };
  },

  /** 4) 시뮬레이터: 대화 이어가기 */
  async simChat({ persona, history }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const p = prompts.personas?.[persona];
    if (!p) throw new Error("유효하지 않은 페르소나입니다.");

    const roleCounselor = prompts.ui?.roleConsultant || "상담사";
    const rolePatient = prompts.ui?.rolePatient || "환자";
    const historyStr = (history || [])
      .map((h) => (h.role === "user" ? roleCounselor : rolePatient) + ": " + h.text)
      .join("\n");

    const prompt = (prompts.simChat || "")
      .replace("{name}", p.name)
      .replace("{description}", p.description)
      .replace("{history}", historyStr);

    const data = await callAi({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      api_name: "counsel_training",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text;
    if (!text) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer: text };
  },

  /** 5) 시뮬레이터: 리포트 */
  async simReport({ persona, history }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const p = prompts.personas?.[persona];
    if (!p) throw new Error("유효하지 않은 페르소나입니다.");

    const roleCounselor = prompts.ui?.roleConsultant || "상담사";
    const rolePatient = prompts.ui?.rolePatient || "환자";
    const historyStr = (history || [])
      .map((h) => (h.role === "user" ? roleCounselor : rolePatient) + ": " + h.text)
      .join("\n");

    const prompt = (prompts.simReport || "")
      .replace("{name}", p.name)
      .replace("{history}", historyStr);

    const data = await callAi({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      api_name: "counsel_training",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const text =
      data?.data?.answer ??
      data?.answer ??
      data?.text ??
      data?.data?.text;
    if (!text) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer: text };
  },
};
